<common-ui-components-page-layout
  [stickyHeader]="true"
  [title]="title()"
>
  <div
    class="p-plus"
    [innerHTML]="content()"
  ></div>
</common-ui-components-page-layout>
